import clock from '~/assets/icons/clock.svg';
import { Button, ButtonColors, ButtonHeight } from '~/components/ui/Button';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import { StyledContainer } from './PlayerWait.styled';

const PlayerWait = () => {
	const otherPlayerName = useObservable(rage.exchange.getOtherPlayerName());

	return (
		<StyledContainer>
			<img src={clock} />
			<Text style={{ fontSize: 18, fontWeight: 500, color: '#ffffff' }}>
				Ожидание {otherPlayerName ?? 'другого игрока'}
			</Text>
			<Text
				style={{
					width: 360,
					textAlign: 'center',
					fontSize: 16,
					color: '#ffffff',
					opacity: 0.25,
					fontStyle: 'italic',
				}}
			>
				Для начала обмена, нужно подождать согласия игрока на его проведение
			</Text>
			<Button
				color={ButtonColors.Default}
				height={ButtonHeight.Height40}
				style={{ width: 184, marginTop: 10 }}
			>
				<Text>Отменить обмен</Text>
			</Button>
		</StyledContainer>
	);
};

export { PlayerWait };
